'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Folder = _ref => {
  let {
    fill,
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends__default["default"]({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.25em",
    height: "1em",
    viewBox: "0 0 20 16"
  }, rest), /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17.5255 2.56001H10.5949C10.4485 2.56043 10.3034 2.53177 10.1681 2.47569C10.0328 2.4196 9.90998 2.33721 9.80678 2.23329L8.08742 0.513926C7.92482 0.350477 7.73142 0.220896 7.51841 0.132683C7.3054 0.0444689 7.07701 -0.000626231 6.84646 6.56854e-06H2.4759C2.01058 0.000430082 1.56443 0.185444 1.23537 0.514447C0.906307 0.84345 0.721211 1.28956 0.720703 1.75489V14.2451C0.721211 14.7104 0.906307 15.1566 1.23537 15.4856C1.56443 15.8146 2.01058 15.9996 2.4759 16H17.5255C17.9908 15.9996 18.437 15.8146 18.766 15.4856C19.0951 15.1566 19.2802 14.7104 19.2807 14.2451V4.31488C19.2802 3.84956 19.0951 3.40345 18.766 3.07445C18.437 2.74544 17.9908 2.56043 17.5255 2.56001ZM18.6407 14.2451C18.6404 14.5408 18.5227 14.8242 18.3137 15.0332C18.1046 15.2422 17.8211 15.3597 17.5255 15.36H2.4759C2.18027 15.3597 1.89681 15.2422 1.68773 15.0332C1.47865 14.8242 1.36104 14.5408 1.3607 14.2451V1.75489C1.36104 1.45925 1.47865 1.17582 1.68773 0.966808C1.89681 0.757792 2.18027 0.64026 2.4759 0.640006H6.84646C6.99292 0.639579 7.13801 0.66824 7.27331 0.724325C7.4086 0.780411 7.53142 0.862804 7.63462 0.966726L9.35398 2.68609C9.51658 2.84953 9.70998 2.97912 9.92299 3.06733C10.136 3.15554 10.3644 3.20064 10.5949 3.20001H17.5255C17.8211 3.20026 18.1046 3.31779 18.3137 3.52681C18.5227 3.73582 18.6404 4.01925 18.6407 4.31488V14.2451Z",
    fill: fill ?? 'currentColor'
  }));
};
/* eslint-enable react/prop-types */

exports["default"] = Folder;
